export const chooseCmp = {
    title: 'エッチバックを選ぶ',
    cmpTitle: '検索したいテーマと国を選択してください。',
    cmpDescription: `Intelligent Business Analyticsでは、ビジネスや技術の観点から対象とする分析範囲を定めテーマを設定しています。\n各テーマに合わせて、IPCやキーワードを基に特許検索式が定義されているため、テーマを選択するだけで関連する技術動向を分析できます。\n「テーマを探す」から収録されている全テーマを確認できますのでご活用ください。`,
    searchBtn: 'テーマを分析する',
    leftSelect: 'テーマを選択',
    toggleLabel: 'バリューチェーン横断に切替',
    rightSelect: '国を選択',
    leftSelectPlaceholder: '英語または日本語でキーワードを入力してください',
    leftJump: 'テーマを探す',
    inputExample: '入力例　Solar cell,ビッグデータ分析技術など',
    cate_01: 'カテゴリ',
    cate_02: 'テーマ名（英）',
    cate_03: 'テーマ名（日）',
    clearAll: '条件をクリア',
    aiRecommend: '近いテーマがあります。変更しますか？'
}
